/** */
import {
  ADD_MANY_ROLES_TO_STORE,
  ADD_ONE_ROLE_TO_STORE,
  ADD_SEARCH_RESULTS_TO_STORE,
  LOAD_ROLES_TO_STORE,
  REM_ONE_ROLE_FROM_STORE
} from '../actions/role';

export default (state = {}, action) => {
  const { type, payload } = action;
  let previous_state;
  switch (type) {
    case ADD_MANY_ROLES_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (roles, role) => ({
            ...roles,
            [role.id]: role
          }),
          {}
        )
      };
    case ADD_ONE_ROLE_TO_STORE:
      return {
        [payload.id]: payload,
        ...state
      };
    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (roles, role) => ({
            ...roles,
            [role.id]: role
          }),
          {}
        )
      };
    case LOAD_ROLES_TO_STORE:
      return {
        ...payload.reduce(
          (roles, role) => ({
            ...roles,
            [role.id]: role
          }),
          {}
        )
      };
    case REM_ONE_ROLE_FROM_STORE:
      previous_state = { ...state };
      delete previous_state[payload];
      return {
        ...previous_state
      };
    default:
      return state;
  }
};
